import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaThLarge, // Dashboard ke liye best alternate
  FaUsers,
  FaCrown,
  FaUserCheck,
  FaPenNib,
  FaQuestionCircle,
  FaExclamationTriangle,
} from "react-icons/fa";
import "./sidebar.css";

export const Sidebar = () => {
  const [open, setOpen] = useState(false);

  const closeSidebarOnMobile = () => {
    if (window.innerWidth < 768) {
      setOpen(false);
    }
  };

  return (
    <>
      <button
        className="sidebar-mobile-btn d-md-none"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>

      <aside className={`sidebar-premium ${open ? "sidebar-open" : ""}`}>
        <div className="sidebar-header d-none d-md-flex px-4 py-3">
          <small
            className="text-uppercase fw-bold text-muted"
            style={{ fontSize: "11px", letterSpacing: "1px" }}
          >
            Main Menu
          </small>
        </div>

        <nav className="sidebar-nav-container">
          <NavLink
            to="/dashboard"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaThLarge className="nav-icon-bs" />
            <span className="nav-text">Dashboard</span>
          </NavLink>

          <NavLink
            to="/users"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaUsers className="nav-icon-bs" />
            <span className="nav-text">Users List</span>
          </NavLink>

          <div className="nav-section-label">Memberships</div>

          <NavLink
            to="/get/plans"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaCrown className="nav-icon-bs text-warning" />
            <span className="nav-text">Pricing Plans</span>
          </NavLink>

          <NavLink
            to="/all/users/plan"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaUserCheck className="nav-icon-bs" />
            <span className="nav-text">Active Members</span>
          </NavLink>

          <div className="nav-section-label">Content & Support</div>

          <NavLink
            to="/blogs"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaPenNib className="nav-icon-bs" />
            <span className="nav-text">Manage Blogs</span>
          </NavLink>

          <NavLink
            to="/queries"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaQuestionCircle className="nav-icon-bs" />
            <span className="nav-text">User Queries</span>
          </NavLink>

          <NavLink
            to="/reports"
            className="nav-link-premium"
            onClick={closeSidebarOnMobile}
          >
            <FaExclamationTriangle className="nav-icon-bs text-danger" />
            <span className="nav-text">Abuse Reports</span>
          </NavLink>
        </nav>
      </aside>

      {open && (
        <div
          className="sidebar-overlay d-md-none"
          onClick={() => setOpen(false)}
        ></div>
      )}
    </>
  );
};
